export default {
  SPIN: 'SNURRA',
  'You are not eligible for free spins':
    'Endast steamkonton med CSGO och utan VAC kvalificerar för gratispoäng. Logga in på sidan igen för att uppdatera.',
  'It must be 24 hours since last roll': '24 timmar måste ha passerat sen senaste kastet.',
};
